const { pick, prop } = require("ramda");

(function () {
  angular.module("ticketco/ticketbuyer/redeem_items")
    .factory("RedeemItemsPersistence", RedeemItemsPersistence);

  function RedeemItemsPersistence($q, $http, Locale) {


    function url(obj) {
      return Locale.url("/reservations/" + obj.ref_number);
    }

    var unwrapResponse = prop("data");

    function validateResponse(res) {
      if (res.errors.length > 0) {
        return $q.reject(res.errors);
      } else {
        return res;
      }
    }

    var permittedParams = pick(["token"]);

    function redeem(obj) {
      return $http.get(url(obj), {
          params: permittedParams(obj)
        })
        .then(unwrapResponse)
        .then(validateResponse);
    }

    return {
      redeem: redeem,
    }
  }

}());
